import React, { Component } from "react";
import $ from 'jquery';
import '../assets/css/font-awesome.min.css';
import '../assets/fonts/fonts.css';
import './Custom.css';
// import ProductDetail from './ProductDetail'
import * as COMMONCONST from '../constants/Common';


class PrivacyPolicy extends Component {

    componentDidMount() {
        COMMONCONST.GAPageView();
    }

    render() {
        $(document).ready(function (d, s, id) { var js, tjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "https://app.termly.io/embed-policy.min.js"; tjs.parentNode.insertBefore(js, tjs); }(document, 'script', 'termly-jssdk'));
        return (
            <div className='App'>
                <div className="cms-page terms-privacy-main">
                    <div className="container">
                        <div name="termly-embed" data-id="61a5bf23-08f1-4344-a44f-5156d87da5bb" data-type="iframe"></div>
                    </div>
                    {/* <ProductDetail></ProductDetail> */}
                </div>

            </div>
        )
    }
}

export default PrivacyPolicy